import React, { useState } from 'react'
import '../../stylings/schoolAwards.css'
import preetDabas    from '../../assest/school awards/preet-dabas.jpeg'
import pariSharma   from '../../assest/school awards/pari-sharma.jpeg'
import nishikaSingh from '../../assest/school awards/nishika-singh.jpeg'
import dplgirls     from '../../assest/school awards/DPL1.jpg'
import dplselection from '../../assest/school awards/DPL2.jpg'

const awards = [
  {
    id: 1,
    title: 'Sub Junior Category Bronze Prize',
    person: 'Preet Dabas',
    date: '28 Oct',
    icon: 'fa-solid fa-medal',
    color: '#cd7f32',
    image: preetDabas,
    featured: true,
  },
  {
    id: 2,
    title: 'Three Girls Selected in DPL',
    person: 'School Team',
    date: '28 Nov',
    icon: 'fa-solid fa-users',
    color: '#f5a623',
    image: dplgirls,
    featured: false,
  },
  {
    id: 3,
    title: 'GEM of School — Selection in DPL',
    person: 'Star Player',
    date: '02 Nov',
    icon: 'fa-solid fa-gem',
    color: '#a855f7',
    image: dplselection,
    featured: false,
  },
  {
    id: 4,
    title: "Women's Under-15 One Day Trophy",
    person: 'Pari Sharma',
    date: '28 Nov',
    icon: 'fa-solid fa-trophy',
    color: '#f5a623',
    image: pariSharma,
    featured: false,
  },
  {
    id: 5,
    title: "Women's Under-19 One Day Trophy",
    person: 'Nishika Singh',
    date: '28 Dec',
    icon: 'fa-solid fa-trophy',
    color: '#f5a623',
    image: nishikaSingh,
    featured: false,
  },
  {
    id: 6,
    title: 'Certificate of Waste Management',
    person: 'School Initiative',
    date: '28 Feb',
    icon: 'fa-solid fa-leaf',
    color: '#22c55e',
    image: preetDabas,
    featured: false,
  },
  {
    id: 7,
    title: 'Certificate of Water Management',
    person: 'School Initiative',
    date: '28 Jan',
    icon: 'fa-solid fa-droplet',
    color: '#3b82f6',
    image: pariSharma,
    featured: false,
  },
]

const stats = [
  { value: '7+', label: 'Awards This Year', icon: 'fa-solid fa-trophy' },
  { value: '2024', label: 'Academic Session', icon: 'fa-solid fa-calendar' },
  { value: '100%', label: 'Excellence Spirit', icon: 'fa-solid fa-star' },
]

const SchoolAwards = () => {
  const [active, setActive] = useState(null)

  return (
    <section className="aw-section" id="schoolAwards">

      {/* ── Decorative blobs ── */}
      <div className="aw-blob aw-blob--1" />
      <div className="aw-blob aw-blob--2" />

      <div className="container" style={{ position: 'relative', zIndex: 1 }}>

        {/* ── Header ── */}
        <div className="aw-header">
          <div className="aw-tag">
            <i className="fa-solid fa-medal"></i>
            Awards &amp; Achievements
          </div>
          <h2 className="aw-title">
            School <span>Awards</span> &amp; <span>Achievements</span>
          </h2>
          <p className="aw-subtitle">
            Celebrating the outstanding accomplishments of our students —<br />
            every trophy tells a story of dedication and hard work.
          </p>

          {/* Stats row */}
          <div className="aw-stats">
            {stats.map((s, i) => (
              <div className="aw-stat" key={i}>
                <i className={s.icon}></i>
                <strong>{s.value}</strong>
                <span>{s.label}</span>
              </div>
            ))}
          </div>
        </div>

        {/* ── Cards grid ── */}
        <div className="aw-grid">
          {awards.map((aw) => (
            <div
              key={aw.id}
              className={`aw-card${aw.featured ? ' aw-card--featured' : ''}${active === aw.id ? ' aw-card--active' : ''}`}
              onMouseEnter={() => setActive(aw.id)}
              onMouseLeave={() => setActive(null)}
            >
              {/* Photo */}
              <div className="aw-card-img-wrap">
                <img src={aw.image} alt={aw.title} className="aw-card-img" />
                <div className="aw-card-vignette" />
              </div>

              {/* Top badges */}
              <div className="aw-card-top">
                <span className="aw-date-pill">
                  <i className="fa-solid fa-calendar-days"></i>
                  {aw.date}
                </span>
                <span className="aw-icon-circle" style={{ '--ic': aw.color }}>
                  <i className={aw.icon}></i>
                </span>
              </div>

              {/* Bottom info */}
              <div className="aw-card-foot">
                <p className="aw-card-title">{aw.title}</p>
                <div className="aw-card-person">
                  <i className="fa-solid fa-user-graduate"></i>
                  {aw.person}
                </div>
              </div>

              {/* Hover glow border */}
              <div className="aw-card-border" style={{ '--ic': aw.color }} />
            </div>
          ))}
        </div>

      </div>
    </section>
  )
}

export default SchoolAwards
